import React, {useState, useEffect} from 'react';
import OtpVerificationPageWithImage from '../../Shared/OtpAuthentication/OtpVerificationPageWithImage';
import {showAppLoader, hideAppLoader} from '../../../Components/Shared/Loader/LoaderSlice';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import {
  PostEcommerceRegistrationCompletion,
  GetCustomerSplitSubscriptionNumberList,
  connectTokenAndRedirect,
  setPreLoginSplitSubscriptionList,
  setSelectedSubscription,
  customerTypes,
  relevantRolePerCustomerType,
  processPhases,
} from './ecommerceOtpSlice';
import SubscribersSelection from '../../Shared/GeneralPages/SubscribersSelection/SubscribersSelection';
import SelectOrganization from './SelectOrganization';
import {otpOrigin} from '../OTPLoginBlock/Assets/variables';

const MainEcommerceOtp = (props) => {
  const getCustomerType = () => {
    if (props.authentication.loginData.isFullAuthenticated) {
      return customerTypes.preFullAuthenticated;
    } else if (props.authentication.loginData.isOtpAuthenticated || props.authentication.loginData.isSilentOtpAuthenticated) {
      return customerTypes.preOtpAuthenticated;
    } else if (props.authentication.loginData.isOtpExtendedAuthenticated) {
      return customerTypes.preOtpExtendedAuthenticated;
    }
    return customerTypes.unIdentifiedCustomer;
  };

  const otpData = props.iContent?.otp?.expandedValue[0];

  const [currentProcessPhase, setCurrentProcessPhase] = useState(processPhases.start);

  const [isPending, setPendingStatus] = useState(true);

  const handlePreLoginMultipleSubscriptionClick = (subscriber) => {
    props.setSelectedSubscription(subscriber);
    setCurrentProcessPhase(processPhases.readyToConnect);
  };

  const getRolesList = async () => {
    if (props.authentication?.loginData?.token) {
      let customerDetails = await authenticationProvider.getUserDetails(props.authentication?.loginData?.token, false, false);
      return customerDetails.RoleList;
    }
  };

  const checkIfRelevantRoleExist = async (customerType) => {
    const customerRoles = props.authentication.loginData.userDetails.RoleList;
    for (let role of customerRoles) {
      if (relevantRolePerCustomerType[customerType]?.includes(role)) {
        return true;
      }
    }
    return false;
  };

  const preFullAuthenticatedCase = async () => {
    let response = await props.GetCustomerSplitSubscriptionNumberList();
    let splitSubscriptionNumberList = response.payload.data;
    let listLen = splitSubscriptionNumberList.length;

    if (listLen === 0) {
      window.open(Config.cellcomShopLink, '_self');
    } else if (listLen === 1) {
      props.setSelectedSubscription(splitSubscriptionNumberList[0]);
      setCurrentProcessPhase(processPhases.readyToConnect);
    } else {
      props.setPreLoginSplitSubscriptionList(splitSubscriptionNumberList);
      setCurrentProcessPhase(processPhases.choseFromSubscriptionList);
    }
  };

  useEffect(() => {
    if (props.authentication.isPending) {
      props.showAppLoader();
    } else {
      props.hideAppLoader();
      setPendingStatus(false);
    }
  }, [props.authentication.isPending]);

  const actionPerCustomerType = async () => {
    const customerType = getCustomerType();
    const isRelevantRoleExist = await checkIfRelevantRoleExist(customerType);
    switch (customerType) {
      case customerTypes.preFullAuthenticated: {
        if (isRelevantRoleExist) {
          preFullAuthenticatedCase();
        } else {
          window.open(Config.cellcomShopLink, '_self');
        }
        break;
      }
      case customerTypes.preOtpExtendedAuthenticated:
      case customerTypes.preOtpAuthenticated:
      case customerTypes.unIdentifiedCustomer: {
        if (isRelevantRoleExist) {
          props.setSelectedSubscription(props.authentication.loginData.userDetails?.contactNumber);
          if (props.authentication.loginData.userDetails.RoleList.includes('OTPSUBSCRIBER_PHONE_NUMBER_ALLOW_ECOMMERCE')) {
            setCurrentProcessPhase(processPhases.selectOrganization);
          } else {
            setCurrentProcessPhase(processPhases.readyToConnect);
          }
        } else {
          window.open(Config.cellcomShopLink, '_self');
        }
        break;
      }
    }
  };

  useEffect(() => {
    if (
      (props.authentication.loginData.isFullAuthenticated ||
        props.authentication.loginData.isOtpAuthenticated ||
        props.authentication.loginData.isOtpExtendedAuthenticated) &&
      currentProcessPhase === processPhases.start
    ) {
      actionPerCustomerType();
    }
  }, [
    props.authentication.loginData.isFullAuthenticated,
    props.authentication.loginData.isOtpAuthenticated,
    props.authentication.loginData.isOtpExtendedAuthenticated,
    props.authentication.loginData.token,
    props.authentication.loginData.userDetails?.contactNumber,
  ]);

  useEffect(() => {
    if (currentProcessPhase === processPhases.readyToConnect && props.ecommerceOtp.selectedSubscription !== '') {
      const sessionLoginType =
        props.authentication.loginData.isOtpAuthenticated || props.authentication.loginData.isOtpExtendedAuthenticated
          ? 'OTP'
          : 'CREDENTIALS';
      props.connectTokenAndRedirect({
        contactValue: props.ecommerceOtp.selectedSubscription,
        loginType: sessionLoginType,
      });
    }
  }, [currentProcessPhase, props.ecommerceOtp.selectedSubscription]);

  const banner = isMobile ? otpData?.imageMobile?.value : otpData?.imageDesktop?.value;
  const bannerMainTitle = isMobile ? otpData?.bannerMainTitleMobile?.value : otpData?.bannerMainTitleDesktop?.value;
  const bannerSecondTitle = isMobile ? otpData?.bannerSecondTitleMobile?.value : otpData?.bannerSecondTitleDesktop?.value;

  const otpTitles = {
    verifyPhoneTitle: otpData?.stepOneTitle?.value,
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    phoneStepButtonText: '',
    verifyCodeTitle: '',
    verifyCodeDescription: '',
    otpCodeStepButtonText: '',
    bannerMainTitle: bannerMainTitle,
    bannerSecondTitle: bannerSecondTitle,
    processType: 'Ecommerce',
  };

  function showOtpPage() {
    return (
      <OtpVerificationPageWithImage
        otpOrigin={otpOrigin.ECOMMERCE}
        originProcess={otpData?.blockSource?.value}
        otpTitles={otpTitles}
        isInline={false}
        otpBanner={banner}
      />
    );
  }

  return (
    <div className='ecommerce-otp'>
      {!isPending &&
        !props.authentication.loginData.isFullAuthenticated &&
        !props.authentication.loginData.isOtpAuthenticated &&
        !props.authentication.loginData.isOtpExtendedAuthenticated &&
        showOtpPage()}
      {currentProcessPhase === processPhases.choseFromSubscriptionList && props.ecommerceOtp.preLoginSplitSubscriptionList && (
        <SubscribersSelection
          subscribers={props.ecommerceOtp.preLoginSplitSubscriptionList}
          onSelectSubscriber={handlePreLoginMultipleSubscriptionClick}
        />
      )}
      {currentProcessPhase === processPhases.selectOrganization && <SelectOrganization setCurrentProcessPhase={setCurrentProcessPhase} />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    ecommerceOtp: state.ecommerceOtp,
  };
};

const mapDispatchToProps = {
  PostEcommerceRegistrationCompletion,
  GetCustomerSplitSubscriptionNumberList,
  setPreLoginSplitSubscriptionList,
  setSelectedSubscription,
  showAppLoader,
  hideAppLoader,
  connectTokenAndRedirect,
};
export default connect(mapStateToProps, mapDispatchToProps)(MainEcommerceOtp);
